// extracted by mini-css-extract-plugin
export default {"root":"style_root__IaLgd","content":"style_content__LSrxo","title":"style_title__IX5Qe","slider":"style_slider__1g3rv"};